import angular from 'angular';

angular
  .module('cloudX')
  .controller('ConfigAddSectionConfigCtrl', [
    'dataCache',
    'resourceFactorySvc',
    'flySvc',
    'translateListFilter',
    'close',
    'sectionId',
    'column',
    'position',
    ConfigAddSectionConfigCtrl,
  ]);

function ConfigAddSectionConfigCtrl(
  dataCache,
  resourceFactorySvc,
  flySvc,
  translateListFilter,
  close,
  sectionId,
  column,
  position,
) {
  var vm = this;
  vm.fields = [];
  resourceFactorySvc.get('field').query(function(data) {
    vm.fields = data.map(x => ({
      ...x,
      display: translateListFilter(x.id, 'field', x.label),
    }));
  });

  vm.config = {
    sectionId: sectionId,
    column: column,
    position: position,
    visibility: null,
    required: [],
    completeness: null,
    countries: null,
    countriesNot: null,
    configurations: null,
  };
  var sectionConfig = resourceFactorySvc.get('sectionConfig');

  vm.save = function() {
    if (!vm.config.fieldId) return;
    sectionConfig.save(
      vm.config,
      function(response) {
        close(response, 500);
        flySvc.success('Field config added');
      },
      function(error) {
        flySvc.error(error.data.code, error.data.parameters);
      },
    );
  };
  vm.cancel = function() {
    close(null, 500);
  };

  vm.changeField = function(field) {
    vm.config.fieldId = field ? field.id : null;
  };
}
